import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faSave } from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../../hooks/useFetch";
import Swal from "sweetalert2";

export default function Direito() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { get, post, put } = useFetch();
    const location = useLocation();

    const [state, setState] = useState({
        acao: location.state?.acao || (id === "criar" ? "Criar" : "Visualizar"),
        dados: { nome_direito: "", descricao: "", permite_reproducao: false }
    });

    useEffect(() => {
        if (id !== "criar") {
            get(`/direitoautoral/${id}`).then(r => {
                if (r.ok) setState(s => ({ ...s, dados: r.result.data }));
            });
        }
    }, [id]);

    const salvar = async () => {
        const method = id === "criar" ? post : put;
        const url = id === "criar" ? '/direitoautoral' : `/direitoautoral/${id}`;
        const response = await method(url, state.dados);
        if (response.ok) {
            Swal.fire({ title: "Sucesso!", icon: "success" });
            navigate("/admin/iconografico/direitos");
        } else {
            Swal.fire({ title: "Não foi possível salvar", icon: "error" });
        }
    };

    return (
        <div className="admin-page-container">
            <div className="mb-4">
                <Link to="/admin/iconografico/direitos" className="btn-back-modern">
                    <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Voltar
                </Link>
            </div>

            <Card className="filter-card-admin">
                <Card.Body className="p-4 p-md-5">
                    <div className="section-title-modern mb-5">
                        <div className="title-accent"></div>
                        <div>
                            <h2 className="admin-title">{state.acao} Direito Autoral</h2>
                            <p className="admin-subtitle small mb-0">Configuração de licenças e permissões de uso</p>
                        </div>
                    </div>

                    <Form>
                        <div className="row g-4">
                            <Form.Group className="col-md-12">
                                <Form.Label className="label-admin">* Nome da Licença / Direito</Form.Label>
                                <Form.Control 
                                    className="input-moderno" 
                                    name="nome_direito" 
                                    value={state.dados.nome_direito} 
                                    onChange={e => setState({...state, dados: {...state.dados, nome_direito: e.target.value}})}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>

                            <Form.Group className="col-md-12">
                                <Form.Label className="label-admin">Descrição Detalhada</Form.Label>
                                <Form.Control 
                                    as="textarea" rows={4}
                                    className="input-moderno" 
                                    name="descricao" 
                                    value={state.dados.descricao} 
                                    onChange={e => setState({...state, dados: {...state.dados, descricao: e.target.value}})}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>

                            <Form.Group className="col-md-12 mt-4">
                                <div className="p-3 rounded-4 border bg-light d-flex align-items-center justify-content-between">
                                    <div>
                                        <h6 className="mb-1 fw-bold">Permitir Reprodução Público?</h6>
                                        <p className="mb-0 text-muted small">Define se a imagem pode ser baixada ou impressa pelos visitantes.</p>
                                    </div>
                                    <Form.Check 
                                        type="switch"
                                        id="reproducao-switch"
                                        className="custom-switch-teal"
                                        checked={state.dados.permite_reproducao}
                                        onChange={e => setState({...state, dados: {...state.dados, permite_reproducao: e.target.checked}})}
                                        disabled={state.acao === "Visualizar"}
                                    />
                                </div>
                            </Form.Group>
                        </div>

                        {state.acao !== "Visualizar" && (
                            <div className="d-flex justify-content-end mt-5 pt-3 border-top">
                                <Button className="btn-apply-filters px-5" onClick={salvar}>
                                    <FontAwesomeIcon icon={faSave} className="me-2" /> Salvar Configuração
                                </Button>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
}